import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { TruthSection } from '../components/TruthSection';
import { ProductIntro } from '../components/ProductIntro';
import { MechanismSection } from '../components/MechanismSection';
import { WhyFailedSection } from '../components/WhyFailedSection';
import { WhatYouGetSection } from '../components/WhatYouGetSection';
import { WhoForSection } from '../components/WhoForSection';
import { TransformSection } from '../components/TransformSection';
import { PricingCTA } from '../components/PricingCTA';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <div className="min-h-screen w-full bg-deep" data-id="element-535">
      <HeroSection data-id="element-536" />
      <ProblemSection data-id="element-537" />
      <TruthSection data-id="element-538" />
      <ProductIntro data-id="element-539" />
      <MechanismSection data-id="element-540" />
      <WhyFailedSection data-id="element-541" />
      <WhatYouGetSection data-id="element-542" />
      <WhoForSection data-id="element-543" />
      <TransformSection data-id="element-544" />
      <PricingCTA data-id="element-545" />
      <Footer data-id="element-546" />
    </div>;
}